import { jsx as r } from "react/jsx-runtime";
import i from "react";
import { c } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
import { G as s } from "./grip-vertical-qyX3LbjG.js";
const m = i.forwardRef(
  ({ className: t, label: e = "Drag handle", testId: o, ...a }, n) => /* @__PURE__ */ r(
    "button",
    {
      ref: n,
      type: "button",
      "aria-label": e,
      "data-testid": o,
      className: c(
        "touch-none cursor-grab active:cursor-grabbing",
        "flex items-center justify-center",
        "text-content-secondary hover:text-content-primary",
        "p-1 rounded focus:outline-none focus:ring-2 focus:ring-focus",
        t
      ),
      ...a,
      children: /* @__PURE__ */ r(s, { size: 16 })
    }
  )
);
m.displayName = "DragHandle";
export {
  m as D
};
